import https from '../init/https';

//BLOG-01 : Get many different blogs to populate blog home page
export async function blogFun(limit, offSet) {
    const result = await https.get(`/blog/home?limit=${limit}&offset=${offSet}`);
    return result;
}

//BLOG-02 : Get complete content of blog based blog id
export async function blogContentFun(blogId) {
    const result = await https.get(`/blog/details/${blogId}`);
    return result;
}

//BLOG-03 : Blogs count
export async function blogCountFun() {
    const result = await https.get(`/blog/count`);
    return result;
}
